import { fetchAdministracion } from "../../http-common";

// const getComboPuesto= (filter) => {
//   return fetchAdministracion.get(`Puesto/ComboByCustomer?`, filter);
// };

const getComboPuesto = (filter) => {
  return fetchAdministracion.get(`Puesto/ComboByCustomer`, { params: {
    filter
  }});
};

const PuestoService = {
    getComboPuesto,
};

export default PuestoService;
